<template>
  <tr v-if="visible">
    <td colspan="9">
      <v-layout class="pt-3 pb-3">
        <v-flex xs9 md9 lg6>
          <v-data-table :items="details.products"
                        :disable-initial-sort="true"
                        :headers="headers"
                        hide-actions
                        class="mr-3"

          >
            <template v-slot:headerCell="{header}">
              <span class="header-cell">{{ header.text }}</span>
              <v-tooltip top v-if="header.tooltip">
                <template v-slot:activator="{on}">
                  <v-icon small v-on="on">help</v-icon>
                </template>
                <span>{{ header.tooltip }}</span>
              </v-tooltip>
            </template>
            <template v-slot:items="{item}">
              <tr>
                <td>
                  {{ item.name }}
                </td>
                <td>
                  {{ item.amount | format_number }} x
                </td>
                <td>
                  {{ item.weight.name }} <span v-if="item.weight.name !== 'gram'">({{ item.weight.weight | format_number }} g)</span>
                </td>
                <td>
                  {{ item.amount * item.weight.weight | round(2) | format_number }} g
                </td>
              </tr>
            </template>
            <template v-slot:footer>
              <tr>
                <td colspan="4" class="footer-cell">
                  <strong>{{ `app.foods.total_weight` | trans }}</strong> {{ totalWeight | round(2) | format_number }} g
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs3 md3 lg6>
          <v-layout column>
            <v-flex xs12 class="pb-1">
              <strong>{{ `app.foods.portions_count`| trans }}:</strong> {{ details.portions }}
            </v-flex>
            <v-flex xs12>
              <strong>{{ `app.foods.recipe` | trans }}:</strong><br/>
              <p class="mb-0 food-recipe">{{ details.recipe }}</p>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout class="pb-1">
        <v-flex xs6>
          <strong>{{ `app.tags.tags` | trans }}:</strong>
          <v-chip
              v-for="tag in details.tags"
              :key="tag.id"
              class="ma-1"
              color="green"
              text-color="white"
          >
            {{ tag.name }}
          </v-chip>
          <span v-if="details.tags.length === 0">-</span>
        </v-flex>
        <v-flex xs6>
          <strong>{{ `app.foods.meals` | trans }}: </strong>
          <v-chip
              v-for="meal in details.meals"
              :key="meal.id"
              class="ma-1"
              color="green"
              text-color="white"
          >
            {{ meal.name }}
          </v-chip>
          <span v-if="details.meals.length === 0">-</span>
        </v-flex>
      </v-layout>
      <v-layout class="pb-3">
        <v-flex xs6>
          <strong>{{ `app.foods.diet` | trans }}: </strong>
          <v-chip
              v-for="diet in details.diets"
              :key="diet.id"
              class="ma-1"
              color="green"
              text-color="white"
          >
            {{ diet.name }}
          </v-chip>
          <span v-if="details.diets.length === 0">-</span>
        </v-flex>
        <v-flex xs6>
          <strong>{{ `app.foods.equipment` | trans }}: </strong>
          <v-chip
              v-for="equipment in details.equipments"
              :key="equipment.id"
              class="ma-1"
              color="green"
              text-color="white"
          >
            {{ equipment.name }}
          </v-chip>
          <span v-if="details.equipments.length === 0">-</span>
        </v-flex>
      </v-layout>
    </td>
  </tr>
</template>
<script>
import {trans} from "../../app";

export default {
  props: {
    foodId: {
      type: Number,
      required: true,
    }
  },
  data: () => ({
    details: {
      products: [],
      recipe: '',
      portions: 0,
      tags: [],
      meals: [],
      diets: [],
      equipments: [],
    },
    cachedDetails: null,
    visible: false,
  }),
  computed: {
    headers() {
      return [
        {
          text: trans('app.product'), align: 'left', sortable: false
        },
        {
          text: trans('app.foods.amount'), align: 'right', sortable: false
        },
        {
          text: trans('app.foods.unit'), align: 'left', sortable: false, tooltip: trans('app.foods.unit_tooltip')
        },
        {
          text: trans('app.foods.total'), align: 'right', sortable: false
        }
      ]
    },
    totalWeight() {
      return this.details.products.reduce((total, product) => {
        return total + (product.amount * product.weight.weight);
      }, 0);
    }
  },
  mounted() {
    this.showFoodDetailsHandler = ((foodId) => {
      if (this.foodId === foodId) {
        this.show(foodId);
      } else {
        this.hide();
      }
    });
    this.$root.$on('show-food-details', this.showFoodDetailsHandler);

    this.invalidateCacheHandler = (() => {
      this.cachedDetails = null;
    });
    this.$root.$on('invalidate-food-details-cache', this.invalidateCacheHandler);
  },
  beforeDestroy() {
    this.$root.$off('show-food-details', this.showFoodDetailsHandler);
    this.$root.$off('invalidate-food-details-cache', this.invalidateCacheHandler);
  },
  methods: {
    async show(foodId) {
      if (this.cachedDetails === null) {
        const response = await axios.get(`/v2/foods/${foodId}`);
        this.cachedDetails = response.data.data;
      }
      this.details = this.cachedDetails;
      this.visible = true;
    },
    hide() {
      this.details = {
        products: [],
        recipe: '',
        portions: 0,
        tags: [],
        meals: [],
        diets: [],
        equipments: [],
      };
      this.visible = false;
    }
  }
}
</script>
<style scoped>
.footer-cell {
  text-align: right;
  padding-right: 24px !important;
}
.header-cell {
  font-weight: bold;
  color: #000000de;
}
.food-recipe {
  white-space: pre-wrap;
}
>>> table {
  background-color: transparent !important;
}
>>> table:hover {
  background-color: transparent;
}
>>> table.v-table thead tr {
  height: 30px;
}
>>> table.v-table thead tr th {
  height: 30px;
}
>>> table.v-table tbody tr {
  height: 30px;
}
>>> table.v-table tbody tr td {
  height: 30px;
}
>>> table.v-table tfoot tr {
  height: 30px;
}
>>> table.v-table tfoot tr td {
  height: 30px;
}
>>> table.v-table tbody tr td:nth-child(1) {
  width: 50%;
}
>>> table.v-table tbody tr td:nth-child(2) {
  text-align: right;
  padding-right: 3px;
}
>>> table.v-table tbody tr td:nth-child(3) {
  padding-left: 3px;
}

>>> table.v-table tbody tr td:nth-child(4) {
  text-align: right;
}

>>> table.v-table thead th:nth-child(1) {
  width: 50%;
}
>>> table.v-table thead th:nth-child(2) {
  text-align: right;
  padding-right: 3px;
}
>>> table.v-table thead th:nth-child(3) {
  padding-left: 3px;
}

>>> table.v-table thead th:nth-child(4) {
  text-align: right;
}
</style>
